import Step1Fields from "../messageCreationFlow/step1/Step1Fields";
import React, {useState} from "react";
import {MessageTemplateProps} from "../../types/MessageTemplateProps";
import {LANGUAGES} from "../../utils/languages";
import {isNotificationFormValid} from "../modals/notificationModals/NotificationFormValidator";
import {ToastSkin} from "../../context/ToastContext";
import useUserContext from "../../hooks/useUserContext";
import {campaignTemplateEditFormValidator} from "./campaignTemplateEditFormValidator";
import {editNotification} from "../../api/editNotification";
import {editCampaignNotification} from "../../api/editCampaignNotification";
import useAppContext from "../../hooks/useAppContext";
import useToast from "../../hooks/useToast";
import Step2Fields from "../messageCreationFlow/step2/Step2Fields";
import Step3Fields from "../messageCreationFlow/step3/Step3Fields";
import MessagePreview from "../messagePreview/MessagePreview";
import {Button} from "antd";
import {CloseOutlined, DeleteFilled, ThunderboltFilled} from "@ant-design/icons";
import TestTemplateButton from "../messageEditFlow/testTemplateButton/TestTemplateButton";
import {useSteps} from "../../hooks/useSteps";
import LongArrowRight from "../../assets/icons/LongArrowRight";

interface CampaignTemplateEditProps {
    template: MessageTemplateProps;
    campaignId: number;
    onTemplateUpdated: () => void;
    onCancel: () => void;
}

const CampaignTemplateEditForm = ({ template, campaignId, onTemplateUpdated, onCancel }: CampaignTemplateEditProps) => {
    const [title, setTitle] = useState(template.title);
    const [language, setLanguage] = useState(template.language);
    const [content, setContent] = useState(template.content);
    const [isWithImage, setIsWithImage] = useState(template.withImage);
    const [imageUrl, setImageUrl] = useState(template.imageUrl);
    const [button1Url, setButton1Url] = useState(template.button1Url);
    const [isCoupon, setIsCoupon] = useState(template.isCoupon);
    const [isLoading, setIsLoading] = useState(false);
    const { selectedDomain } = useUserContext();
    const { actions: { loadCampaigns }} = useAppContext();
    const { showToast } = useToast();
    const { goNext } = useSteps();

    const isDirty = title !== template.title || content !== template.content || !isWithImage !== !template.withImage || !isCoupon !== !template.isCoupon || imageUrl !== template.imageUrl || button1Url !== template.button1Url;

    const selectedLanguage = LANGUAGES.find(lang => lang.key === language);
    const direction = selectedLanguage?.direction === 'rtl' ? 'rtl' : 'ltr';

    const onEditCampaignTemplate = async () => {
        setIsLoading(true);
        const errors = campaignTemplateEditFormValidator({
            title,
            content,
        });
        if(selectedDomain && !errors.length) {
            try {
                const response = await editCampaignNotification(selectedDomain, campaignId, template.id, {
                    title, content, language, isWithImage, isCoupon, imageUrl, button1Url,
                });
                setIsLoading(false);
                loadCampaigns();
                onTemplateUpdated();
            } catch (error) {
                console.log("error2: ", error);
                showToast({ skin: ToastSkin.error, text: 'Failed to save your template'});
            }
        } else {
            showToast({ text: errors?.length ? errors[0] : 'Failed to save your template'});
        }
        setIsLoading(false);
        return false;
    }


    return (
        <div className="edit-flow-container">
            <div className="left">
                <Step1Fields setIsLoading={setIsLoading} imageUrl={imageUrl} setImageUrl={setImageUrl} title={title} setTitle={setTitle} language={language} setLanguage={setLanguage} content={content} setContent={setContent} isWithImage={isWithImage} setIsWithImage={setIsWithImage} isCoupon={isCoupon} setIsCoupon={setIsCoupon} id={template.id} isCampaign={true} direction={direction} button1Url={button1Url} setButton1Url={setButton1Url} />
                <div className="buttons">
                    <div className="button-row">
                        <Button type="default" size="large" className="back-step-button" onClick={onCancel} icon={<CloseOutlined />}>Close</Button>
                        {isDirty ?
                            <Button type="primary" size="large" className="next-step-button" loading={isLoading} onClick={onEditCampaignTemplate} icon={<ThunderboltFilled />} disabled={!title || !content}>Update Template</Button>
                            : <Button type="primary" size="large" className="next-step-button" loading={isLoading} onClick={() => goNext()} iconPosition="end" icon={<LongArrowRight width={14} color='#fff' />}>Next</Button>}
                    </div>
                </div>
            </div>
            <div className="right">
                <MessagePreview
                    text={content}
                    isWithImage={isWithImage}
                    direction={direction}
                    language={language}
                    imageUrl={imageUrl}
                />
            </div>
        </div>
    );
}

export default CampaignTemplateEditForm;